<template>
  <div class="text-options-setting-dialog">
    <el-collapse v-model="activeNames" style="width: 100%">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <el-collapse-item
        v-if="isShowSerialNumber"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="数据组"
        name="2"
        class="paddingtb8"
      >
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
        >
          <div v-for="(item, index) in serialNumberHeaderData" :key="index">
            <collapsibleItem>
              <div slot="heading">{{ item.value }}</div>
              <div slot="body">
                <div class="data-item">
                  <collapsibleItem>
                    <div slot="heading">内容设置</div>
                    <div slot="body">
                      <div class="data-item">
                        <div class="font14">对齐方式</div>
                        <el-radio-group
                          v-model="item.align"
                          @change="getSerialNumberHeaderDataAlignHandle(index, $event)"
                        >
                          <el-radio label="left">左</el-radio>
                          <el-radio label="center">中</el-radio>
                          <el-radio label="right">右</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="data-item mt16">
                        <div class="font14">内容类型</div>
                        <el-radio-group
                          v-model="item.type"
                          @change="getSerialNumberHeaderDataTypeHandle(index, $event)"
                        >
                          <el-radio label="text">文本</el-radio>
                          <el-radio label="image">图片</el-radio>
                        </el-radio-group>
                      </div>
                      <div v-if="item.type === 'text'" class="data-item mt16">
                        <text-setting-update
                          @update:fontSize="getSerialNumberHeaderDataFontHandle(index, 'fontSize', $event)"
                          @update:fontFamily="getSerialNumberHeaderDataFontHandle(index, 'fontFamily', $event)"
                          @update:fontWeight="getSerialNumberHeaderDataFontHandle(index, 'fontWeight', $event)"
                          @update:fontColor="getSerialNumberHeaderDataFontHandle(index, 'fontColor', $event)"
                          :fontColor.sync="item.fontColor"
                          :fontFamily.sync="item.fontFamily"
                          :fontSize.sync="item.fontSize"
                          :fontWeight.sync="item.fontWeight"
                          :themeKey="request_prefix"
                        />
                      </div>
                      <div v-if="item.type === 'image'" class="data-item mt16">
                        <double-input
                          @update:value1="getSerialNumberHeaderDataImageWHandle(index, $event)"
                          @update:value2="getSerialNumberHeaderDataImageHHandle(index, $event)"
                          title="尺寸"
                          placeHolderText="必填"
                          :value1.sync="item.width"
                          :value2.sync="item.height"
                          :inputSuffixs="['宽', '高']"
                        />
                      </div>
                      <div v-if="item.type === 'image'" class="data-item mt16">
                        <slider-and-input
                          @change="getSerialNumberHeaderDataImageBorderRadiusHandle(index, $event)"
                          :value.sync="item.borderRadius"
                          title="圆角"
                          titlePosition="allInOneLine"
                          :sliderMax="sliderMaxTime"
                          suffix="px"
                        />
                      </div>
                      <div class="content-item mt16" v-if="item.type !== 'image'">
                        <el-checkbox
                          v-model="item.isDesensitization"
                          @change="getSerialNumberHeaderDataIsDesensitizationHandle(index, $event)"
                          >是否脱敏</el-checkbox
                        >
                        <div class="tm-type mt12" v-if="item.isDesensitization">
                          <el-radio-group
                            v-model="item.isDesensitizationCenter"
                            @change="getSerialNumberHeaderDataIsDesensitizationCenterHandle(index, $event)"
                          >
                            <el-radio label="false">全部脱敏</el-radio>
                            <el-radio label="true" class="mt8">脱敏中间字符</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                  </collapsibleItem>
                </div>
              </div>
            </collapsibleItem>
          </div>
          <collapsibleItem>
            <div slot="heading">动态数据</div>
            <div slot="body">
              <div class="content-item mb16">
                <span class="mr16">表头文字</span>
                <el-input style="width: 136px" v-model="dynamicHeaderName"></el-input>
              </div>
              <div class="data-item">
                <div class="font14">对齐方式</div>
                <el-radio-group
                  v-model="dynamicDataAlign"
                >
                  <el-radio label="left">左</el-radio>
                  <el-radio label="center">中</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <div v-for="(item, index) in dynamicData" class="content-item mb16 specialRows_content">
                <div class="delete-btn" @click="deleteDynamicDataHandle(index)">
                  <span class="icon-portal-delete1"></span>
                </div>
                <div class="data-item mb12">
                  <div class="font14 mb8">条件设置</div>
                  <el-radio-group class="mb8" v-model="item.type" @change="getDynamicDataTypeHandle(index, $event)">
                    <el-radio label="singleValue">单值判断</el-radio>
                    <el-radio label="range">区间范围</el-radio>
                  </el-radio-group>
                </div>
                <div class="data-item mb8">
                  <el-select
                    style="width: 183px; height: 32px"
                    v-model="item.target"
                    @change="getDynamicDataTargetHandle(index, $event)"
                  >
                    <el-option v-for="(item, index) in options.headerData" :key="index" :label="item" :value="item">
                      {{ item }}
                    </el-option>
                  </el-select>
                </div>
                <div v-if="item.type === 'singleValue'" class="data-item mb8">
                  <el-select
                    style="width: 183px; height: 32px"
                    v-model="item.condition"
                    @change="getDynamicDataConditionHandle(index, $event)"
                  >
                    <el-option v-for="(item, index) in conditionList" :key="index" :label="item" :value="item">
                      {{ item }}
                    </el-option>
                  </el-select>
                </div>
                <div v-if="item.type === 'range'" class="data-item mb8">
                  <single-input
                    @change="getDynamicDataConditionRange1Handle(index, $event, 0)"
                    style="width: 64px; height: 32px"
                    :value.sync="item.conditionRange[0]"
                    :noInputSuffixs="true"
                  />
                  <!--                  <el-input-->
                  <!--                    @change="getDynamicDataConditionRange1Handle(index, $event)"-->
                  <!--                    style="width: 64px; height: 32px"-->
                  <!--                    v-model="item.conditionRange[0]"-->
                  <!--                    placeholder="请输入"-->
                  <!--                    v-inputHandle="{ this1, type: 'conditionRange' }"-->
                  <!--                    type="number"-->
                  <!--                  >-->
                  <!--                  </el-input>-->
                  <span> < 值 <= </span>
                  <single-input
                    @change="getDynamicDataConditionRange1Handle(index, $event, 1)"
                    style="width: 64px; height: 32px"
                    :value.sync="item.conditionRange[1]"
                    :noInputSuffixs="true"
                  />
                  <!--                  <el-input-->
                  <!--                    @change="getDynamicDataConditionRange2Handle(index, $event)"-->
                  <!--                    style="width: 64px; height: 32px"-->
                  <!--                    v-model="item.conditionRange[1]"-->
                  <!--                    placeholder="请输入"-->
                  <!--                    v-inputHandle="{ this1, type: 'conditionRange' }"-->
                  <!--                    type="number"-->
                  <!--                  >-->
                  <!--                  </el-input>-->
                </div>
                <div v-if="item.type === 'singleValue'" class="data-item mb8">
                  <el-input
                    v-model="item.parameter"
                    @change="getDynamicDataParameterHandle(index, $event)"
                    placeholder="参数值"
                  ></el-input>
                </div>
                <div class="data-item mb8">
                  <div class="font14 mb8">文字内容</div>
                  <el-input
                    v-model="item.result"
                    @change="getDynamicDataResultHandle(index, $event)"
                    placeholder="请输入"
                  ></el-input>
                </div>
                <div class="data-item">
                  <p class="mb8 fs14">文字样式</p>
                  <text-setting-update
                    @update:fontSize="getDynamicDataFontHandle(index, 'resultFontSize', $event)"
                    @update:fontFamily="getDynamicDataFontHandle(index, 'resultFontFamily', $event)"
                    @update:fontWeight="getDynamicDataFontHandle(index, 'resultFontWeight', $event)"
                    @update:fontColor="getDynamicDataFontHandle(index, 'resultFontColor', $event)"
                    :fontColor.sync="item.resultFontColor"
                    :fontFamily.sync="item.resultFontFamily"
                    :fontSize.sync="item.resultFontSize"
                    :fontWeight.sync="item.resultFontWeight"
                    :themeKey="request_prefix"
                  />
                </div>
              </div>
              <div class="addConditionBtn" @click="addDynamicDataHandle">
                <span class="icon-portal-plus mr2"></span>
                <span class="">添加条件</span>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" title="列配置" name="3">
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
        >
          <div class="data-item">
            <div class="font14 mb8">列数量</div>
            <el-radio-group v-model="showColsType" @change="changeShowColsTypeHandle($event)">
              <el-radio label="all">全部展示</el-radio>
              <el-radio label="customize">自定义展示</el-radio>
            </el-radio-group>
            <div v-if="showColsType === 'customize'" class="mt16">
              <span class="mr16 fs14">每页显示列数</span>
              <single-input
                style="width: 60px; height: 32px"
                :value.sync="showCols"
                inputSuffixs="列"
                @change="getShowColsHandle($event)"
              />
              <!--              <el-input-->
              <!--                style="width: 60px; height: 32px"-->
              <!--                v-inputHandle="{ this1, type: 'showCols' }"-->
              <!--                type="number"-->
              <!--                v-model="showCols"-->
              <!--                placeholder="请输入"-->
              <!--                @change="getShowColsHandle($event)"-->
              <!--              >-->
              <!--                <template slot="suffix">-->
              <!--                  <span class="suffix_text">列</span>-->
              <!--                </template>-->
              <!--              </el-input>-->
            </div>
          </div>
          <div class="data-item mt16">
            <div class="font14 mb8">列宽</div>
            <el-radio-group v-model="colsWidthType">
              <el-radio label="default">平均列宽</el-radio>
              <el-radio label="auto">自定义宽度</el-radio>
            </el-radio-group>
            <div v-if="colsWidthType === 'auto'">
              <div class="mt20" v-if="isShowSerialNumber">
                <slider-and-input
                  :value.sync="rankWidth"
                  title="序号列"
                  :themeKey="request_prefix"
                  :sliderMax="sliderMaxTime"
                  suffix="%"
                />
              </div>
              <div v-for="(value, index) in colsWidthList" class="mt20">
                <slider-and-input
                  :value.sync="colsWidthList[index]"
                  :title="'第' + (index + 1) + '列'"
                  :themeKey="request_prefix"
                  :sliderMax="sliderMaxTime"
                  suffix="%"
                  @change="getChangeHandle($event, index)"
                />
              </div>
            </div>
          </div>
          <div class="data-item mt16">
            <div class="font14 mb16 verticallyCenter">
              溢出文本<i
                class="tips-btn icon-portal-info2"
                v-if="request_prefix !== 'bigScreen'"
                @click="explainDialogClick('text')"
              ></i>
            </div>
            <el-radio-group v-model="overflowText">
              <el-radio label="wrap">换行展示</el-radio>
              <el-radio label="single">单行省略</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
        title="行配置"
        name="4"
        class="paddingtb8"
      >
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
        >
          <collapsibleItem>
            <div slot="heading">默认行配置</div>
            <div slot="body" class="mt8">
              <div class="data-item">
                <p class="font14 mb8">行高度</p>
                <slider-and-input
                  inputWidth="large"
                  inputHeight="small"
                  :value.sync="rowsHeight"
                  title=""
                  :themeKey="request_prefix"
                  titlePosition="singleLine"
                  :sliderMax="sliderMax"
                  suffix="px"
                />
              </div>
              <div class="data-item mt16">
                <div class="font14 mb8">行数量</div>
                <el-radio-group v-model="showRowsType">
                  <el-radio label="all">全部展示</el-radio>
                  <el-radio label="customize">自定义展示</el-radio>
                </el-radio-group>
                <div v-if="showRowsType === 'customize'" class="mt16">
                  <span class="mr16 fs14">每页显示行数</span>
                  <single-input style="width: 60px; height: 32px" :value.sync="showRows" inputSuffixs="行" />
                  <!--                  <el-input-->
                  <!--                    style="width: 60px; height: 32px"-->
                  <!--                    v-inputHandle="{ this1, type: 'showRows' }"-->
                  <!--                    type="number"-->
                  <!--                    v-model="showRows"-->
                  <!--                    placeholder="请输入"-->
                  <!--                  >-->
                  <!--                    <template slot="suffix">-->
                  <!--                      <span class="suffix_text">行</span>-->
                  <!--                    </template>-->
                  <!--                  </el-input>-->
                </div>
              </div>
              <div class="data-item mt16">
                <div class="font14 mb8">奇行背景色</div>
                <el-radio-group v-model="oddBgColorType">
                  <el-radio label="纯色">纯色</el-radio>
                  <el-radio label="线性渐变">线性渐变</el-radio>
                </el-radio-group>
                <div v-if="oddBgColorType === '纯色'" class="color-picker-container mt12">
                  <el-color-picker
                    class=""
                    v-model="oddBgColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ oddBgColor }}</span>
                </div>
                <div v-if="oddBgColorType === '线性渐变'" class="mt12">
                  <span class="mr16 fs14">开始颜色</span>
                  <div class="color-picker-container custom-text-bg">
                    <el-color-picker
                      class=""
                      v-model="oddBgStartColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ oddBgStartColor }}</span>
                  </div>
                </div>
                <div v-if="oddBgColorType === '线性渐变'" class="mt12">
                  <span class="mr16 fs14">结束颜色</span>
                  <div class="color-picker-container custom-text-bg">
                    <el-color-picker
                      class=""
                      v-model="oddBgEndColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ oddBgEndColor }}</span>
                  </div>
                </div>
              </div>
              <div class="data-item mt16">
                <div class="font14 mb8">偶行背景色</div>
                <el-radio-group v-model="evenBgColorType">
                  <el-radio label="纯色">纯色</el-radio>
                  <el-radio label="线性渐变">线性渐变</el-radio>
                </el-radio-group>
                <div v-if="evenBgColorType === '纯色'" class="color-picker-container mt12">
                  <el-color-picker
                    class=""
                    v-model="evenBgColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ evenBgColor }}</span>
                </div>
                <div v-if="evenBgColorType === '线性渐变'" class="mt12">
                  <span class="mr16 fs14">开始颜色</span>
                  <div class="color-picker-container custom-text-bg">
                    <el-color-picker
                      class=""
                      v-model="evenBgStartColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ evenBgStartColor }}</span>
                  </div>
                </div>
                <div v-if="evenBgColorType === '线性渐变'" class="mt12">
                  <span class="mr16 fs14">结束颜色</span>
                  <div class="color-picker-container custom-text-bg">
                    <el-color-picker
                      class=""
                      v-model="evenBgEndColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ evenBgEndColor }}</span>
                  </div>
                </div>
              </div>
              <div v-if="!isShowSerialNumber" class="data-item mt16">
                <div class="font14 mb16">文字样式</div>
                <text-setting-update
                  :fontColor.sync="defaultFontColor"
                  :fontFamily.sync="defaultFontFamily"
                  :fontSize.sync="defaultFontSize"
                  :fontWeight.sync="defaultFontWeight"
                  :themeKey="request_prefix"
                />
                <text-align-setting class="mt8" :textAlign.sync="textAlign" :hasItemWidth="textAlignItemWidth" />
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem>
            <div slot="heading" class="">
              <div class="verticallyCenter">
                特殊行配置<i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('row')"></i>
              </div>
              <span @click.stop="addSpeciaRowHandle()" class="icon-portal-plus theme-color right-add"></span>
            </div>
            <div slot="body" class="mt8">
              <div v-for="(item, index) in specialRows" class="content-item mb16 specialRows_content">
                <div class="delete-btn" @click="deleteSpeciaRowHandle(index)">
                  <span class="icon-portal-delete1"></span>
                </div>
                <div class="data-item verticallyCenter">
                  <span class="mr12 fs14 w56">行数</span>
                  <div class="floatLeft input_box">
                    <single-input style="width: 100px" :value.sync="item.rowIndex" inputSuffixs="行" />
                    <!--                    <el-input-->
                    <!--                      style="width: 100px"-->
                    <!--                      type="number"-->
                    <!--                      v-model="item.rowIndex"-->
                    <!--                    >-->
                    <!--                      <template slot="suffix">-->
                    <!--                        <span class="suffix_text">行</span>-->
                    <!--                      </template>-->
                    <!--                    </el-input>-->
                  </div>
                </div>
                <div class="data-item mt8">
                  <span class="mr16 fs14">背景颜色</span>
                  <div class="color-picker-container custom-container-bg">
                    <el-color-picker
                      class=""
                      v-model="item.specialBgColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ item.specialBgColor }}</span>
                  </div>
                </div>
                <div v-if="!isShowSerialNumber" class="data-item mt8">
                  <p class="mb8 fs14">文字样式</p>
                  <text-setting-update
                    :fontColor.sync="item.specialFontColor"
                    :fontFamily.sync="item.specialFontFamily"
                    :fontSize.sync="item.specialFontSize"
                    :fontWeight.sync="item.specialFontWeight"
                    :themeKey="request_prefix"
                  />
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="isShowSerialNumber"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="序号配置"
        name="5"
        class="paddingtb8"
      >
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
        >
          <cx-check-box :value.sync="isShowRank" :themeKey="request_prefix" class="mt8">显示序号</cx-check-box>
          <div class="content-item mt16">
            <span class="mr16">表头文字</span>
            <el-input style="width: 136px" v-model="rankName"></el-input>
          </div>
          <div class="data-item mt8">
            <div class="font14">对齐方式</div>
            <el-radio-group
              v-model="rankAlign"
            >
              <el-radio label="left">左</el-radio>
              <el-radio label="center">中</el-radio>
              <el-radio label="right">右</el-radio>
            </el-radio-group>
          </div>
          <collapsibleItem v-if="isShowRank">
            <div slot="heading">默认行配置</div>
            <div slot="body" class="mt8">
              <div class="content-item mt16">
                <!--                <cx-check-box class="mt8" :value.sync="serialNumberShowRankText" :themeKey="request_prefix"-->
                <!--                  >显示排名文本</cx-check-box-->
                <!--                >-->
                <text-setting-update
                  class="mt8"
                  v-if="serialNumberShowRankText"
                  :fontColor.sync="serialNumberRankTextFontColor"
                  :fontFamily.sync="serialNumberRankTextFontFamily"
                  :fontSize.sync="serialNumberRankTextFontSize"
                  :fontWeight.sync="serialNumberRankTextFontWeight"
                  :themeKey="request_prefix"
                />
              </div>
              <div class="content-item mt16">
                <cx-check-box :value.sync="serialNumberShowSerialNumberBg" :themeKey="request_prefix"
                  >显示序号背景</cx-check-box
                >
                <div class="data-item mt16 verticallyCenter">
                  <span class="mr16 fs14">背景样式</span>
                  <el-select class="flex1" style="height: 32px" v-model="serialNumberBgType">
                    <el-option
                      v-for="(item, index) in serialNumberBgTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </el-option>
                  </el-select>
                </div>
                <div class="data-item mt16" v-if="serialNumberBgType === 'image'">
                  <img-upload-simple :imgSrc.sync="serialNumberBgImg" />
                </div>
                <div class="data-item mt16">
                  <double-input
                    title="尺寸"
                    placeHolderText="必填"
                    :value1.sync="serialNumberBgW"
                    :value2.sync="serialNumberBgH"
                    :inputSuffixs="['宽', '高']"
                  />
                </div>
                <div
                  class="data-item mt16"
                  v-if="serialNumberBgType === 'roundedRectangle' || serialNumberBgType === 'image'"
                >
                  <slider-and-input
                    :value.sync="serialNumberBgRadius"
                    title="圆角"
                    titlePosition="allInOneLine"
                    :sliderMax="sliderMaxTime"
                    suffix="px"
                  />
                </div>
                <div class="data-item mt16">
                  <span class="mr16 fs14">背景颜色</span>
                  <div class="color-picker-container flex1 mt8">
                    <el-color-picker
                      v-model="serialNumberBgColor"
                      color-format="rgba"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ serialNumberBgColor }}</span>
                  </div>
                </div>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem v-if="isShowRank">
            <div slot="heading">
              特殊行配置<span
                @click.stop="addSerialNumberSpeciaRowHandle()"
                class="icon-portal-plus theme-color right-add"
              ></span>
            </div>
            <div slot="body" class="mt8">
              <div v-for="(item, index) in serialNumberSpecialRows" class="content-item mb16 specialRows_content">
                <div class="delete-btn" @click="deleteSerialNumberSpeciaRowHandle(index)">
                  <span class="icon-portal-delete1"></span>
                </div>
                <div class="data-item verticallyCenter">
                  <span class="mr16 fs14 w56">行数</span>
                  <div class="floatLeft input_box">
                    <single-input style="width: 100px" :value.sync="item.rowIndex" inputSuffixs="行" />
                    <!--                    <el-input-->
                    <!--                      style="width: 100px"-->
                    <!--                      type="number"-->
                    <!--                      v-inputHandle="{ this1, type: 'rowIndex' }"-->
                    <!--                      v-model="item.rowIndex"-->
                    <!--                    >-->
                    <!--                      <template slot="suffix">-->
                    <!--                        <span class="suffix_text">行</span>-->
                    <!--                      </template>-->
                    <!--                    </el-input>-->
                  </div>
                </div>
                <div class="data-item mt8" v-if="serialNumberBgType === 'image'">
                  <img-upload-simple :imgSrc.sync="item.specialBgImg" />
                </div>
                <div class="data-item mt8">
                  <span class="mr16 fs14">背景颜色</span>
                  <div class="color-picker-container custom-container-bg">
                    <el-color-picker
                      class=""
                      v-model="item.specialBgColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ item.specialBgColor }}</span>
                  </div>
                </div>
                <div class="data-item mt8">
                  <span class="mb8 fs14">文字样式</span>
                  <text-setting-update
                    :fontColor.sync="item.specialFontColor"
                    :fontFamily.sync="item.specialFontFamily"
                    :fontSize.sync="item.specialFontSize"
                    :fontWeight.sync="item.specialFontWeight"
                    :themeKey="request_prefix"
                  />
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')" title="表头" name="6">
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
        >
          <div class="content">
            <div class="content-item verticallyCenter">
              <el-checkbox v-model="showHeader">显示表头</el-checkbox>
            </div>
            <div v-if="showHeader" class="content-item verticallyCenter mt16">
              <span class="mr12 fs14">表头背景色</span>
              <div class="color-picker-container flex1">
                <el-color-picker v-model="headerBgColor" color-format="rgba" :show-alpha="true"></el-color-picker>
                <span class="floatLeft color-text mr8">{{ headerBgColor }}</span>
              </div>
            </div>
            <div v-if="showHeader" class="content-item mt16">
              <p class="font14 mb8">表头高度</p>
              <slider-and-input
                inputWidth="large"
                inputHeight="small"
                :value.sync="headerHeight"
                title=""
                :themeKey="request_prefix"
                titlePosition="singleLine"
                :sliderMax="sliderMax"
                suffix="px"
              />
            </div>
            <div v-if="showHeader" class="content-item mt16">
              <div class="mb8">文字样式</div>
              <text-setting-update
                :fontColor.sync="headerFontColor"
                :fontFamily.sync="headerFontFamily"
                :fontSize.sync="headerFontSize"
                :fontWeight.sync="headerFontWeight"
                :themeKey="request_prefix"
              />
              <text-align-setting v-if="!isShowSerialNumber" class="mt8" :textAlign.sync="headerTextAlign" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="$store.state.states.showPluginSetting"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
        title="插件"
        name="8"
      >
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <p class="fs14 tips" v-if="explainTitle1">
        <span>{{ explainTitle1 }}：</span>{{ explainTips1 }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import CollapsibleItem from "modules/components/collapsibleItem"
import SeriesSetting from "./tableSourceData"
import TextSetting from "modules/components/textSetting"
import ImgUpload from "modules/components/imgUpload"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
export default {
  name: "text-options-data",
  components: {
    ImgUpload,
    TextSetting,
    CollapsibleItem,
    TextSettingComplex,
    controlWidthAndSizeAndZindex,
    SeriesSetting,
    elementPluginSetting,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3", "9"],
      allCollapseNames: ["4", "5", "6", "7", "8"],
      collapseActiveNames: ["1", "2", "3", "9"],
      activeType: 1,
      sliderMaxTime: 100,
      sliderMax: 360,
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      collapseDataActiveNames: [],
      serialNumberBgTypeList: [
        {
          label: "圆角矩形",
          value: "roundedRectangle"
        },
        {
          label: "圆形",
          value: "round"
        },
        {
          label: "菱形",
          value: "diamond"
        },
        {
          label: "图片",
          value: "image"
        }
      ],
      conditionList: ["等于", "不等于", "包含", "不包含", "大于", "小于"],
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainTitle1: "",
      explainTips1: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      textAlignItemWidth: 68
    }
  },
  computed: {
    isShowSerialNumber() {
      // 是否为序列表格
      if (!this.options.isShowSerialNumber) {
        // 兼容普通表格
        this.$changeOptionsEV(false, "isShowSerialNumber", false, false, false, true)
      }
      return this.options.isShowSerialNumber
    },
    isShowRank: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isShowRank", "isShowRank", true) // 以前的表格没有这个属性，兼容老数据
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isShowRank", false)
      }
    },
    rankName: {
      get() {
        let rankName = "排名"
        if (this.options.rankName !== undefined) {
          rankName = this.options.rankName
        }
        return rankName
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rankName", false)
      }
    },
    rankAlign:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rankAlign", "rankAlign", "center") // 以前的表格没有这个属性，兼容老数据
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rankAlign", false)
      }
    },
    dynamicHeaderName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dynamicHeaderName", "dynamicHeaderName", "动态数据") // 以前的表格没有这个属性，兼容老数据
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dynamicHeaderName", false)
      }
    },
    dynamicDataAlign:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dynamicDataAlign", "dynamicDataAlign", "center") // 以前的表格没有这个属性，兼容老数据
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dynamicDataAlign", false)
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    showColsType: {
      get() {
        return this.options.showColsType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showColsType", false)
      }
    },
    showCols: {
      get() {
        return this.options.showCols
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showCols", false)
        if (this.colsWidthType === "auto") {
          this.changeShowColsTypeHandle("customize")
        }
      }
    },
    colsWidthType: {
      get() {
        return this.options.colsWidthType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colsWidthType", false)
        if (newVal === "auto") {
          if (this.showColsType === "all") {
            this.changeShowColsTypeHandle()
          } else {
            this.changeShowColsTypeHandle("customize")
          }
        }
      }
    },
    colsWidthList: {
      get() {
        if (!this.options.colsWidthList) {
          let colsWidthList = []
          if (this.colsWidthType === "customize") {
            for (let i = 0; i < this.showCols; i++) {
              colsWidthList.push(parseInt(100 / this.showCols))
            }
          } else {
            for (let i = 0; i < this.options.headerData.length; i++) {
              colsWidthList.push(parseInt(100 / this.options.headerData.length))
            }
          }
          this.$changeOptionsEV(colsWidthList, "colsWidthList", false, false, false, true)
        }
        return this.options.colsWidthList
      }
    },
    serialNumberHeaderData: {
      get() {
        if (this.isShowSerialNumber) {
          // 序列表格才有数据组
          return this.options.serialNumberHeaderData
        }
      }
    },
    dynamicData: {
      get() {
        if (this.isShowSerialNumber) {
          // 序列表格才有数据组
          return this.options.dynamicData
        }
      }
    },
    overflowText: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "overflowText", "overflowText", "single")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "overflowText", false)
      }
    },
    dataList: {
      get() {}
    },
    autoWidthType: {
      get() {
        return this.options.autoWidthType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "autoWidthType", false)
      }
    },
    showRowsType: {
      get() {
        return this.options.showRowsType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRowsType", false)
      }
    },
    rowsHeight: {
      get() {
        return this.options.rowsHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rowsHeight", false)
      }
    },
    showRows: {
      get() {
        return this.options.showRows
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRows", false)
      }
    },
    oddBgColorType: {
      get() {
        return this.options.oddBgColorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "oddBgColorType", false)
      }
    },
    oddBgColor: {
      get() {
        return this.options.oddBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "oddBgColor", false)
      }
    },
    oddBgStartColor: {
      get() {
        return this.options.oddBgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "oddBgStartColor", false)
      }
    },
    oddBgEndColor: {
      get() {
        return this.options.oddBgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "oddBgEndColor", false)
      }
    },
    evenBgColorType: {
      get() {
        return this.options.evenBgColorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "evenBgColorType", false)
      }
    },
    evenBgColor: {
      get() {
        return this.options.evenBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "evenBgColor", false)
      }
    },
    evenBgStartColor: {
      get() {
        return this.options.evenBgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "evenBgStartColor", false)
      }
    },
    evenBgEndColor: {
      get() {
        return this.options.evenBgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "evenBgEndColor", false)
      }
    },
    defaultFontFamily: {
      get() {
        return this.options.defaultFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultFontFamily", false)
      }
    },
    defaultFontSize: {
      get() {
        return this.options.defaultFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultFontSize", false)
      }
    },
    defaultFontWeight: {
      get() {
        return this.options.defaultFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultFontWeight", false)
      }
    },
    defaultFontColor: {
      get() {
        return this.options.defaultFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultFontColor", false)
      }
    },
    specialRows: {
      get() {
        return this.options.specialRows
      }
    },
    showHeader: {
      get() {
        return this.options.showHeader
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showHeader", false)
      }
    },
    headerBgColor: {
      get() {
        return this.options.headerBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerBgColor", false)
      }
    },
    headerHeight: {
      get() {
        return this.options.headerHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerHeight", false)
      }
    },
    headerFontFamily: {
      get() {
        return this.options.headerFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerFontFamily", false)
      }
    },
    headerFontSize: {
      get() {
        return this.options.headerFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerFontSize", false)
      }
    },
    headerFontWeight: {
      get() {
        return this.options.headerFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerFontWeight", false)
      }
    },
    headerFontColor: {
      get() {
        return this.options.headerFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerFontColor", false)
      }
    },
    serialNumberShowRankText: {
      get() {
        return this.options.serialNumberShowRankText
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberShowRankText", false)
      }
    },
    serialNumberRankTextFontFamily: {
      get() {
        return this.options.serialNumberRankTextFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberRankTextFontFamily", false)
      }
    },
    serialNumberRankTextFontSize: {
      get() {
        return this.options.serialNumberRankTextFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberRankTextFontSize", false)
      }
    },
    serialNumberRankTextFontWeight: {
      get() {
        return this.options.serialNumberRankTextFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberRankTextFontWeight", false)
      }
    },
    serialNumberRankTextFontColor: {
      get() {
        return this.options.serialNumberRankTextFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberRankTextFontColor", false)
      }
    },
    serialNumberShowSerialNumberBg: {
      get() {
        return this.options.serialNumberShowSerialNumberBg
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberShowSerialNumberBg", false)
      }
    },
    serialNumberBgType: {
      get() {
        return this.options.serialNumberBgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberBgType", false)
      }
    },
    serialNumberBgImg: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "serialNumberBgImg", "serialNumberBgImg", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberBgImg", false)
      }
    },
    serialNumberBgW: {
      get() {
        return this.options.serialNumberBgW
      },
      set(newVal) {
        if (this.serialNumberBgType === "round" || this.serialNumberBgType === "diamond") {
          this.$changeOptionsEV([newVal, newVal], ["serialNumberBgH", "serialNumberBgW"], false)
        } else {
          this.$changeOptionsEV(newVal, "serialNumberBgW", false)
        }
      }
    },
    serialNumberBgH: {
      get() {
        return this.options.serialNumberBgH
      },
      set(newVal) {
        if (this.serialNumberBgType === "round" || this.serialNumberBgType === "diamond") {
          this.$changeOptionsEV([newVal, newVal], ["serialNumberBgW", "serialNumberBgH"], false)
        } else {
          this.$changeOptionsEV(newVal, "serialNumberBgH", false)
        }
      }
    },
    serialNumberBgRadius: {
      get() {
        return this.options.serialNumberBgRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberBgRadius", false)
      }
    },
    serialNumberBgColor: {
      get() {
        return this.options.serialNumberBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "serialNumberBgColor", false)
      }
    },
    serialNumberSpecialRows() {
      return this.options.serialNumberSpecialRows
    },
    showPagination: {
      get() {
        return this.options.showPagination
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showPagination", false)
      }
    },
    hoverStopScroll: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverStopScroll", "hoverStopScroll", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverStopScroll", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    waitTime: {
      get() {
        return this.options.waitTime
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "waitTime", false)
      }
    },
    textAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "textAlign", "textAlign", "center")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    headerTextAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "headerTextAlign", "headerTextAlign", "center")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "headerTextAlign", false)
      }
    },
    rankWidth: {
      get() {
        let widthDefault = parseInt(100 / this.options.headerData.length)
        if(this.options.hasOwnProperty("rankWidth")){
          widthDefault = this.options.rankWidth
        }
        return widthDefault
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rankWidth", false)
      }
    }
  },
  methods: {
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      console.log("$event", $event.isActive)
      console.log("this.collapse", this.collapse)
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    changeShowColsTypeHandle($event) {
      let colsWidthList = []
      if ($event === "customize") {
        for (let i = 0; i < this.showCols; i++) {
          colsWidthList.push(parseInt(100 / this.showCols))
        }
      } else {
        for (let i = 0; i < this.options.headerData.length; i++) {
          colsWidthList.push(parseInt(100 / this.options.headerData.length))
        }
      }
      this.$changeOptionsEV(colsWidthList, "colsWidthList", false)
    },
    getChangeHandle($event, index) {
      const colsWidthList = [...this.colsWidthList]
      colsWidthList[index] = $event
      this.$changeOptionsEV(colsWidthList, "colsWidthList", false)
    },
    getShowColsHandle($event) {
      let colsWidthList = []
      for (let i = 0; i < $event; i++) {
        colsWidthList.push(parseInt(100 / $event))
      }
      this.$changeOptionsEV(colsWidthList, "colsWidthList", false)
    },
    // 新增特殊行点击事件
    addSpeciaRowHandle() {
      let addRow = {
        rowIndex: 1,
        specialBgColorType: "纯色", // "纯色"、"线性渐变"、"径向渐变"
        specialBgColor: "rgba(0,4,58,0)",
        specialBgStartColor: "rgba(0,4,58,1)",
        specialBgEndColor: "rgba(19,32,148,1)",
        specialFontFamily: "sans-serif",
        specialFontSize: 16,
        specialFontWeight: 400,
        specialFontColor: "rgba(255, 255, 255, 0.8)"
      }
      let specialRows = JSON.parse(JSON.stringify(this.specialRows))
      addRow.rowIndex = specialRows.length + 1
      specialRows.push(addRow)
      this.$changeOptionsEV(specialRows, "specialRows", false)
    },
    // 删除特殊行点击事件
    deleteSpeciaRowHandle(index) {
      let specialRows = JSON.parse(JSON.stringify(this.specialRows))
      specialRows.splice(index, 1)
      this.$changeOptionsEV(specialRows, "specialRows", false)
    },
    // 序号配置中新增特殊行点击事件
    addSerialNumberSpeciaRowHandle() {
      let addRow = {
        rowIndex: 1,
        specialBgColor: "rgba(0,4,58,1)",
        specialFontFamily: "sans-serif",
        specialFontSize: 12,
        specialFontWeight: 400,
        specialFontColor: "rgba(0, 0, 0, 0.8)",
        specialBgImg: ""
      }
      let specialRows = JSON.parse(JSON.stringify(this.serialNumberSpecialRows))
      addRow.rowIndex = specialRows.length + 1
      specialRows.push(addRow)
      this.$changeOptionsEV(specialRows, "serialNumberSpecialRows", false)
    },
    // 序号配置中删除特殊行点击事件
    deleteSerialNumberSpeciaRowHandle(index) {
      let specialRows = JSON.parse(JSON.stringify(this.serialNumberSpecialRows))
      specialRows.splice(index, 1)
      this.$changeOptionsEV(specialRows, "serialNumberSpecialRows", false)
    },
    // 排序表格改变对齐方式
    getSerialNumberHeaderDataAlignHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".align", false)
    },
    // 排序表格改变数据显示类型
    getSerialNumberHeaderDataTypeHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".type", false)
    },
    // 排序表格改变文字样式
    getSerialNumberHeaderDataFontHandle(index, type, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + "." + type, false)
    },
    // 排序表格改变图片宽度
    getSerialNumberHeaderDataImageWHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".width", false)
    },
    // 排序表格改变图片高度
    getSerialNumberHeaderDataImageHHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".height", false)
    },
    // 排序表格改变图片圆角
    getSerialNumberHeaderDataImageBorderRadiusHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".borderRadius", false)
    },
    // 排序表格是否脱敏
    getSerialNumberHeaderDataIsDesensitizationHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".isDesensitization", false)
      if ($event) {
        this.$changeOptionsEV("false", "serialNumberHeaderData." + index + ".isDesensitizationCenter", false)
      }
    },
    // 排序表格是否脱敏中间内容，保留第一个和最后一个字符
    getSerialNumberHeaderDataIsDesensitizationCenterHandle(index, $event) {
      this.$changeOptionsEV($event, "serialNumberHeaderData." + index + ".isDesensitizationCenter", false)
    },
    // 排序表格添加动态数据条件点击事件
    addDynamicDataHandle() {
      let addDynamicData = {
        type: "singleValue", // singleValue: 单值判断；range: 区间范围
        target: "", // 目标变量
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        conditionRange: [0, 10],
        parameter: "", // 参数值
        result: "", // 结果
        resultFontSize: 12,
        resultFontFamily: "sans-serif",
        resultFontWeight: "400",
        resultFontColor: "rgba(255, 255, 255, 0.8)"
      }
      let dynamicData = JSON.parse(JSON.stringify(this.options.dynamicData))
      dynamicData.push(addDynamicData)
      this.$changeOptionsEV(dynamicData, "dynamicData", false)
    },
    // 排序表格删除动态数据条件点击事件
    deleteDynamicDataHandle(index) {
      let dynamicData = JSON.parse(JSON.stringify(this.options.dynamicData))
      dynamicData.splice(index, 1)
      this.$changeOptionsEV(dynamicData, "dynamicData", false)
    },
    // 排序表格动态数据切换条件设置
    getDynamicDataTypeHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".type", false)
    },
    // 排序表格动态数据改变目标变量
    getDynamicDataTargetHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".target", false)
    },
    // 排序表格动态数据改变条件
    getDynamicDataConditionHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".condition", false)
    },
    // 排序表格动态数据改变条件范围1
    getDynamicDataConditionRange1Handle(index, $event, index1) {
      let conditionRange = this.options.dynamicData[index].conditionRange
      conditionRange[index1] = $event
      this.$changeOptionsEV(conditionRange, "dynamicData." + index + ".conditionRange", false)
    },
    // 排序表格动态数据改变条件范围2
    getDynamicDataConditionRange2Handle(index, $event) {
      let conditionRange = this.options.dynamicData[index].conditionRange
      conditionRange[1] = $event
      this.$changeOptionsEV(conditionRange, "dynamicData." + index + ".conditionRange", false)
    },
    // 排序表格动态数据改变参数值
    getDynamicDataParameterHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".parameter", false)
    },
    // 排序表格动态数据改变结果
    getDynamicDataResultHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".result", false)
    },
    // 排序表格动态数据改变结果的文字样式
    getDynamicDataFontHandle(index, type, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + "." + type, false)
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "text":
          this.explainTitle = "换行显示"
          this.explainTips = "单元格内文本过长时自动换行显示单行省略"
          this.explainTitle1 = "单行省略"
          this.explainTips1 = "单元格内文本过长时省略显示"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/table-text.png")
          break
        case "row":
          this.explainTitle = "特殊行配置"
          this.explainTips =
            "点击➕后，当前行会变为特殊行，可以对特殊行进行单独的样式设置及调整。例如：排行榜表格的前3行样式配置。"
          this.explainTitle1 = ""
          this.explainTips1 = ""
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/special-row.png")
          break
        default:
      }
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.mb8 {
  margin-bottom: 8px;
}
.color-picker-container.custom-text-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.paddingl0 {
  padding-left: 0;
}
.specialRows_content {
  border: 1px solid #313336;
  border-radius: 4px;
  padding: 12px;
  position: relative;
}
.specialRows_content .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--sliderBackGround);
  border-radius: 0px 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.specialRows_content .delete-btn .icon-portal-delete1 {
  top: 4.83px;
  left: 5.5px;
  position: absolute;
}
.specialRows_content .delete-btn .icon-portal-delete1:before {
  color: var(--toolbarTipText);
}
.specialRows_content .color-picker-container.custom-container-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.right-add {
  position: absolute;
  right: 5px;
  line-height: 24px;
  cursor: pointer;
}
.input_box {
  flex: 1;
}
.addConditionBtn {
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  width: 102px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.collapsible-item .item-heading > div {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  align-items: center;
}
.tm-type {
  padding: 12px;
  border-radius: 4px;
  background-color: var(--toobarTopBgColor);
}
</style>
